import { useRouter } from 'next/router';
import { TBasicTokenInfo } from '@shared/types/frontend/assetPage';
import { Button } from '@/components/ui/button';
import { useSession } from '@/contexts/LitSessionProvider';
import { useRecentToken } from '@/hooks/saved/useRecentToken';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import { CATEGORIES, EVENTS, LogToMixpanel } from '@/lib/misc/mixpanel';
import TokenImage from '@/components/shared/TokenImage';
import useAppDetails from '@/hooks/utilities/useAppDetails';
import { adjustNativeTokenData } from '@/hooks/asset/useTokenData';
interface Props {
  data: TBasicTokenInfo[];
  onTokenClick?: (token: any) => void;
}
export default function RecentResults({
  data,
  onTokenClick
}: Props) {
  const {
    PKP
  } = useSession();
  const {
    handleClearRecentTokens
  } = useRecentToken();
  const router = useRouter();
  const {
    setMobileMode,
    setMobileModeMetadata
  } = useAppDetails();
  if (!data || data?.length < 1) return;
  return <div className='w-full ta-l pb-1' data-sentry-component="RecentResults" data-sentry-source-file="RecentResults.tsx">
      <div className='flex justify-between items-center w-full px-4'>
        <p className='text-[20px] font-medium text-genius-gradient flex items-center'>Recent</p>
        <Button variant='purple' className='text-[14px] h-8' onClick={() => {
        handleClearRecentTokens();
      }} data-sentry-element="Button" data-sentry-source-file="RecentResults.tsx">
          Clear
        </Button>
      </div>
      <div className='flex items-center pt-2.5 gap-x-2 overflow-x-scroll no-scrollbar px-3'>
        {data?.map((item, index) => {
        const token = adjustNativeTokenData(item).token;
        return <div key={index} className='rounded-full flex items-center gap-x-2 border border-genius-blue py-1.5 px-2.5' onClick={() => {
          if (onTokenClick) {
            LogToMixpanel({
              pkp: PKP,
              eventName: EVENTS.search.clickTopToken,
              category: CATEGORIES.search,
              metaData: {
                tokenAddress: token.address,
                networkId: token.networkId
              }
            });
            onTokenClick(token);
          } else {
            setMobileMode('asset');
            setMobileModeMetadata({
              networkId: token.networkId,
              address: token.address,
              prev_m_mode: 'search'
            });
            router.push(`/home?m_mode=asset&networkId=${token?.networkId}&address=${token?.address}`, undefined, {
              shallow: true
            });
          }
        }}>
              <TokenImage mainImageSrc={token.info?.imageThumbUrl} badgeImageSrc={getNetworkLogo(token.networkId)} size={24} badgeSize={12} />
              <div className='text-[14px] text-genius-cream overflow-hidden max-w-[100px] whitespace-nowrap overflow-ellipsis'>
                {token.name}
              </div>
            </div>;
      })}
      </div>
    </div>;
}